import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import MenuReducer from 'components/Menu/reducer.js';
import NotificationReducer from 'components/Notification/reducer.js';
import CarTypeReducer from 'pages/CarType/reducer.js';
import NeedCarReducer from 'pages/NeedCar/reducer.js';
import BudgetReducer from 'pages/Budget/reducer.js';
import PhoneReducer from 'pages/Phone/reducer.js';
import BirthdayReducer from 'pages/Birthday/reducer.js';
import WorkingReducer from 'pages/Working/reducer.js';
import NameReducer from 'pages/Name/reducer.js';
import GenderReducer from 'pages/Gender/reducer.js';
import ExperienceReducer from 'pages/Experience/reducer.js';
import MounthlyReducer from 'pages/Mounthly/reducer.js';
import ConfirmationReducer from 'pages/Confirmation/reducer.js';
import UploadReducer from 'pages/Upload/reducer.js';
import LoginReducer from 'pages/Login/reducer.js';
import SearchReducer from 'pages/Search/reducer.js';
import ApprovedReducer from 'pages/Approved/reducer.js';
import CarPageReducer from 'pages/CarPage/reducer.js';
import SignatureReducer from 'pages/Signature/reducer.js';
import EmailReducer from 'pages/Email/reducer.js';
import ProfileCarsReducer from 'pages/ProfileCars/reducer.js';
import LoadScreenReducer from 'components/LoadScreen/reducer.js';
import LoginAdminReducer from 'pages/LoginAdmin/reducer.js';
import CarEditorPageReducer from 'pages/CarEditorPage/reducer.js';
import AdminRestorePassReducer from 'pages/AdminRestorePass/reducer.js';

export default combineReducers({
  routing: routerReducer,
  menu: MenuReducer,
  notification: NotificationReducer,
  phone: PhoneReducer,
  birthday: BirthdayReducer,
  working: WorkingReducer,
  carType: CarTypeReducer,
  needs: NeedCarReducer,
  budget: BudgetReducer,
  name: NameReducer,
  gender: GenderReducer,
  experience: ExperienceReducer,
  mounthly: MounthlyReducer,
  confirmation: ConfirmationReducer,
  file: UploadReducer,
  user: LoginReducer,
  search: SearchReducer,
  approved: ApprovedReducer,
  car: CarPageReducer,
  signature: SignatureReducer,
  email: EmailReducer,
  profileCars: ProfileCarsReducer,
  loadscreen: LoadScreenReducer,
  loginadmin: LoginAdminReducer,
  careditor: CarEditorPageReducer,
  adminrestorepass: AdminRestorePassReducer
});



// WEBPACK FOOTER //
// ./src/store/reducer.js